import styled from "styled-components";

import UpdateButton from "@EditArticleContainer/shared/components/UpdateButton/UpdateButton";

export const ParagraphMAStructureWrapper = styled.div`
  position: relative;

  .ma-structure-value-text {
    padding: 0;
    border-radius: 0;
  }

  @media only screen and (min-width: 361px) {
    .ma-structure-value-text {
      padding: 0.8rem;
    }
  }
`;

export const ParagraphMAStructureUpdateButton = styled(UpdateButton)`
  position: absolute;
  left: -1.6rem;
  top: 0;
  transform: translateX(-100%);
`;
